import axios from './axiosConfig';
import { QuoteAnalyticsResponse } from '../types/analytics.types';

const API_BASE_URL = '/quote-analytics';

export const analyticsApi = {
  getQuoteConversionMetrics: async (): Promise<QuoteAnalyticsResponse> => {
    const response = await axios.get<QuoteAnalyticsResponse>(`${API_BASE_URL}/conversion-metrics`);
    return response.data;
  },
};
